$(function(){
	var pathname = window.location.pathname;
	if(pathname === "/gift-cards" || pathname === "/gift-cards.htm"){
		var couponurl = "/ajax/coupon/sort.htm";
	}else{
		var couponurl = "/ajax/buyonline/sort.htm";
	}

    var allStores = $("#all-stores"), $window = $(window), loader = '<div class="loader"></div>',
        sorter = $("#sort-merchants"),
        holder = $(".holder"),
        stats = function(cat, action, label){
            $(document).trigger("stats", {data: ["send", "event", cat, action, label || '']});
            return true;
        },
        sort = function(e, d){
            var selected, cat, type;
            $(this).addClass("selected").siblings("div").removeClass("selected");
            $(this).parent().find(".sort-cat").toggle();
            selected = sorter.find("div.selected"),
            type = selected.text();
            holder.text(type);

            allStores.prepend(loader);
            $.get(couponurl, {sort: selected.data("value")}).done(function(data){
                allStores.html(data);
                !d && stats("Luxe - All Stores", "Sort", type + " - " + (cat || "All"));
            });
        },
        inView = function (el, threshhold){ // TODO - move it to global ebates object
            var st = $window.scrollTop(), top = el.offset().top, offset = threshhold || 0;
            return top + el.height() < st + $window.height() + offset && top > st - offset;
        };
        sorter.on("click",".sort-cat div", sort);
        sort(true);

    $("body").on("click",".lux-cat-list li .ajax, .lux-subhead", function(){
        allStores.prepend(loader);
        $("li a", $(".lux-cat-list")).removeClass("semibold");
        $(this).addClass('semibold');
        $("li a", $(".lux-cat-list")).addClass("wed-selected");

        $.get(couponurl, {sort: sorter.find("div.selected").data("value")}).done(function(data){
            allStores.html(data);
            stats("Luxe - All Stores", "Category Filter", allStores.find("ul").data("cat") || "All");
        });
        return false;
    });

    //  scroll GA events
    $(".scroll-section").each(function(){
        var $this = $(this), listener = function(){
            inView($this) && stats("Luxe - All Stores", "Section view", $this.attr("data-section")) && $window.off("scroll-throttle", listener);
        };
        $window.on("scroll-throttle", listener);
    });

	if((pathname === "/free-shipping" || pathname === "/buy-online-pickup-in-store" || pathname === "/gift-cards") && $("#coup_des").length > 0){
		$(function(){
			var sticky = $("#side-scroll-target"), bottom = $("#coup_des"), margin = 0;
				sticky.offset().top + sticky.height() + margin < bottom.offset().top && setTimeout(
				jQuery.proxy(ebates.stickyModule, null, sticky, bottom, $("#side-scroll-top"), $("#header-main"), margin), 1000);
		});
	}
});
